function initializeBazaarVoiceCustom() {
  document.addEventListener('click', (event) => {

    // When BazaarVoice rating button is clicked, expand Reviews accordion
    const button = event.target.closest('button');
    if (button && (button.classList.contains('bv_main_rating_button') || button.classList.contains('bv_button_buttonFull'))) {
      const ratingAccordionButton = document.querySelector('[data-bs-target="#reviews-collapse"][aria-expanded="false"]');

      if (ratingAccordionButton) {
        ratingAccordionButton.click();
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', event => {
  initializeBazaarVoiceCustom();
});